import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "sobre-mi", label: "Sobre mí" },
  { id: "servicios", label: "Servicios" },
  { id: "por-que-elegirme", label: "Por qué elegirme" },
  { id: "contacto", label: "Contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-[#E2E8F0]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#sobre-mi"
          onClick={(e) => {
            e.preventDefault();
            go("sobre-mi");
          }}
          data-testid="nav-logo"
          className="font-display text-xl tracking-tight text-[#0A192F]"
        >
          Melina<span className="italic text-[#475569]">.Marketing</span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <li key={l.id}>
              <button
                onClick={() => go(l.id)}
                data-testid={`nav-${l.id}`}
                className="link-underline text-sm uppercase tracking-[0.18em] text-[#0A192F]"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          onClick={() => go("contacto")}
          data-testid="nav-cta-button"
          className="hidden md:inline-flex btn-lift bg-[#0A192F] text-white px-5 py-2.5 text-xs uppercase tracking-[0.2em]"
        >
          Trabajemos juntas
        </button>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#0A192F]"
          data-testid="nav-mobile-toggle"
          aria-label="Abrir menú"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t border-[#E2E8F0]" data-testid="mobile-menu">
          <ul className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => go(l.id)}
                  data-testid={`mobile-nav-${l.id}`}
                  className="text-sm uppercase tracking-[0.18em] text-[#0A192F]"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => go("contacto")}
                data-testid="mobile-nav-cta"
                className="w-full bg-[#0A192F] text-white px-5 py-3 text-xs uppercase tracking-[0.2em]"
              >
                Trabajemos juntas
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
